<div class="header">
  <strong class="title">Modify Configuration</strong>
  @if ((config() | keyvalue)?.length > 0) {
    <fw-icon-button
      fwTooltip="Reset to Defaults"
      fwTooltipPosition="right"
      icon="rotate-refresh"
      size="small"
      test-id="reset-config-button"
      (click)="confirmReset()"
    />
  }
</div>
@if ((config() | keyvalue)?.length === 0) {
  <div>There are no configuration options for this gear.</div>
}
<form [formGroup]="form">
  @for (parameter of config() | keyvalue; track parameter.key) {
    <div class="gear-config-parameter" test-id="gear-config-parameter">
      <div class="gear-config-info">
        <span fwTooltipPosition="left" [fwTooltip]="parameter?.value?.description">
          {{ parameter.key }}
        </span>
      </div>
      <div class="gear-config-value">
        @if ($any(parameter.value).items?.enum) {
          <!-- Enumerated array -->
          <fw-wrapped-input [errorText]="getError(parameter.key)">
            <fw-multi-select
              test-id="gear-config-field"
              width="100%"
              [formControlName]="parameter.key"
              [placeholder]="getPlaceholder(parameter.key)"
            >
              @for (option of $any(parameter.value).items.enum; track $index) {
                <fw-menu-item [title]="toString(option)" [value]="toString(option)" />
              }
            </fw-multi-select>
          </fw-wrapped-input>
        } @else if (parameter.value?.enum) {
          <!-- Single value enum -->
          <fw-wrapped-input [errorText]="getError(parameter.key)">
            <fw-select
              test-id="gear-config-field"
              width="100%"
              [formControlName]="parameter.key"
              [placeholder]="getPlaceholder(parameter.key)"
            >
              @for (option of parameter.value.enum; track $index) {
                <fw-menu-item [title]="toString(option)" [value]="toString(option)" />
              }
            </fw-select>
          </fw-wrapped-input>
        } @else {
          @switch (parameter.value.type) {
            @case ('array') {
              <!-- Unbounded array -->
              <fw-wrapped-input [errorText]="getError(parameter.key)">
                <fw-typeahead
                  test-id="gear-config-field"
                  [formControlName]="parameter.key"
                  [placeholder]="getPlaceholder(parameter.key)"
                />
              </fw-wrapped-input>
            }
            @case ('boolean') {
              <fw-checkbox test-id="gear-config-field" [formControlName]="parameter.key" />
            }
            @default {
              <fw-wrapped-input [errorText]="getError(parameter.key)">
                @switch (parameter.value.type) {
                  @case ('integer') {
                    <fw-text-input
                      test-id="gear-config-field"
                      type="number"
                      [formControl]="$any(form.get(parameter.key))"
                      [placeholder]="getPlaceholder(parameter.key)"
                    />
                  }
                  @case ('number') {
                    <fw-text-input
                      test-id="gear-config-field"
                      type="number"
                      [formControl]="$any(form.get(parameter.key))"
                      [placeholder]="getPlaceholder(parameter.key)"
                    />
                  }
                  @default {
                    <fw-text-input
                      test-id="gear-config-field"
                      type="text"
                      [formControl]="$any(form.get(parameter.key))"
                      [maxLength]="null"
                      [placeholder]="getPlaceholder(parameter.key)"
                    />
                  }
                }
              </fw-wrapped-input>
            }
          }
        }
      </div>
    </div>
  }
</form>
